import React, { useEffect, useState } from "react"
import { CSSTransition } from "react-transition-group"
import { useLifecycles } from "react-use"
import { useForm } from "react-hook-form"
import Modal from "../Modal"
import { validationRules } from "../checkout2/constants"
import { Input, InputTextarea } from "../checkout2/ui/input"
import { vacanciesFormApi } from "../api/vacancies"

export default function ModalVacanciesForm() {
  const [isSelfOpen, setIsSelfOpen] = useState(true)
  const [isSuccessOpen, setIsSuccessOpen] = useState(false)
  const [isSendingForm, setIsSendingForm] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors, defaultValues, isValid },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onTouched",
    shouldFocusError: true,
    defaultValues: {
      name: "",
      phone: "",
      about: "",
      city: "",
    },
  })

  const handleModalClose = (e) => {
    e.stopPropagation()
    if (!e.target.closest(".modal-content") || e.target.classList.contains("js-close")) {
      setIsSelfOpen(false)
    }
  }

  const onSubmit = (data) => {
    const payload = {
      ...data,
    }
    payload["phone"] = payload["phone"].replace(/\D/g, "")

    try {
      setIsSendingForm(true)
      vacanciesFormApi(payload)
        .then(() => {
          // Show success message modal
          setIsSuccessOpen(true)
          setIsSelfOpen(false)
        })
        .catch((error) => {
          console.log("Error: ", error)
        })
        .finally(() => {
          setIsSendingForm(false)
        })
    } catch (error) {
      console.log("Error: ", error)
    }
  }

  useEffect(() => {
    window.maskedInput()
  }, [])

  useLifecycles(() => {
    document.documentElement.classList.add("overflow")
  })

  return (
    <>
      <CSSTransition
        in={isSelfOpen}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
        onExit={() => {
          document.documentElement.classList.remove("overflow")
        }}
      >
        <>
          <div
            className="modal modal--mobile-bottom-sheet modal--vacancies-form"
            data-target="modal-vacancies-form"
            style={{ display: "block" }}
            onClick={handleModalClose}
          >
            <div className="modal__zoom">
              <div className="modal-content modal-contect--narrow">
                <div className="close-btn js-close" onClick={handleModalClose} />
                <div className="modal__content">
                  <div className="modal__title">
                    {window.labels.vacancies.forms.formModalTitle}
                  </div>
                  <div className="modal__subtitle">
                    {window.labels.vacancies.forms.modalSubtitle}
                  </div>
                  <div className="modal__content-body scrolling-block">
                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      id="vacancies_form"
                      className="vacancies-form"
                    >
                      <div className="form-label-list">
                        <Input
                          title={window.labels.vacancies.forms.questionnaire.name}
                          type="text"
                          autoComplete="off"
                          focus={Boolean(defaultValues.name)}
                          isError={Boolean(errors["name"])}
                          {...register("name", {
                            required: true,
                            setValueAs: (value) => value.trim(),
                          })}
                        />
                        <Input
                          title={window.labels.vacancies.forms.questionnaire.phone}
                          type="tel"
                          autoComplete="off"
                          isError={Boolean(errors["phone"])}
                          {...register("phone", {
                            ...validationRules["phone"],
                          })}
                        />
                        <Input
                          title={window.labels.vacancies.forms.questionnaire.city}
                          type="text"
                          autoComplete="off"
                          isError={Boolean(errors["city"])}
                          {...register("city", {
                            required: true,
                          })}
                        />
                        <InputTextarea
                          title={window.labels.vacancies.forms.questionnaire.about}
                          isError={Boolean(errors["about"])}
                          {...register("about", {
                            required: true,
                          })}
                        />
                      </div>
                    </form>
                    <span className="vacancies-form-agree">
                      {window.labels.vacancies.forms.agreeText}
                    </span>
                  </div>

                  {/* <Footer /> */}
                  <div className="row_btn">
                    <button
                      type="submit"
                      className={`wb-btn btn-green vacancies-form-submit ${
                        isSendingForm || !isValid ? "disabled" : ""
                      }`}
                      form="vacancies_form"
                      disabled={isSendingForm || !isValid}
                    >
                      {window.labels.vacancies.forms.sendButton}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </CSSTransition>
      <CSSTransition
        in={isSuccessOpen}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
      >
        <Modal
          title={window.labels.vacancies.forms.successModalTitle}
          modalView="xs"
          cssModifyer="-mobile-bottom-sheet modal--vacancies-success"
          onRequestClose={() => setIsSuccessOpen(false)}
        >
          <div className="form-content">
            <p className="body-r-16">
              <span>{window.labels.vacancies.forms.successModalText}</span>
            </p>
            <a href={window.labels.vacancies.forms.homeLinkUrl || "/"} className="successful-home-link">
              {window.labels.vacancies.forms.homeLinkText || "Home"}
            </a>
          </div>
        </Modal>
      </CSSTransition>
    </>
  )
}
